import { render } from "./sell-out-chart.vue?vue&type=template&id=41672d40"
import script from "./sell-out-chart.vue?vue&type=script&lang=ts"
export * from "./sell-out-chart.vue?vue&type=script&lang=ts"
script.render = render

export default script